"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVisualizationsTheme = void 0;
var colors_1 = require("./colors");
var theme_1 = require("@epic-ui/theme");
var createVisualizationsTheme = function (themeOptions) {
    if (themeOptions === void 0) { themeOptions = {}; }
    var _a = (0, theme_1.createEpicTheme)(), palette = _a.palette, typography = _a.typography, zIndex = _a.zIndex;
    return __assign({ defaultBackground: palette.background.default, defaultText: palette.text.primary, axisLabel: palette.text.secondary, axisColor: palette.divider, axisFontSize: typography.caption.fontSize, gridColor: palette.action.selected, tooltipBackground: palette.background.overlays, tooltipLabel: palette.text.primary, zIndexTooltip: zIndex.tooltip, 
        // Map
        landmassColor: palette.background.overlays, limitsColor: palette.background.paper, comparisonColors: [
            colors_1.Colors.Blue500,
            colors_1.Colors.Green700,
            colors_1.Colors.Yellow500,
            colors_1.Colors.Red500,
            colors_1.Colors.Blue300,
            colors_1.Colors.Green300,
            colors_1.Colors.Yellow300,
            colors_1.Colors.Red300,
            colors_1.Colors.Purple300,
            colors_1.Colors.Yellow700,
            colors_1.Colors.Yellow900,
            colors_1.Colors.Red600,
            colors_1.Colors.Purple500,
            colors_1.Colors.Blue600,
            colors_1.Colors.Green500,
        ] }, themeOptions);
};
exports.createVisualizationsTheme = createVisualizationsTheme;
//# sourceMappingURL=theme.js.map